const MODULE = "SOURCE_FILES";
const action = action => `${MODULE}_${action}`;

export const sourceFilterFilesConstants = {
	RESET_FILTERS: action("RESET_FILTERS"),
	SET_FILTERS: action("SET_FILTERS"),
	REMOVE_FILTER: action("REMOVE_FILTER"),
};
